import { type DocumentNode, gql } from '@apollo/client';

const deleteItemCollection: DocumentNode = gql`
  mutation deleteItemCollection($assetIds: [ID], $collectionId: ID!) {
    deleteItemsFromCollection(assetIds: $assetIds, collectionId: $collectionId) {
      collection {
        id
        items {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;

export default deleteItemCollection;
